"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcBillingListItemHeader = class UcBillingListItemHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    newItem: this.$fn.pgettext("BillingListItem", "New item"),
                    editItem: this.$fn.pgettext("BillingListItem", "Edit item"),
                },
                ux: null,
            },
        };
    }
    get resourceTitle() {
        if (this.loaded) {
            return this.$fn.pgettext("BillingListItem", "Billing list item");
        }
        return null;
    }
    get resourceKey() {
        if (this.loaded) {
            return this.item.isNew ? this.messages.newItem : this.messages.editItem;
        }
        return null;
    }
    async act_1040167445267876_emit_6650_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_1040167445267876_clickPreventStop(event, scope) {
        return await this.actions.evh_1040167445267876_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3601807637515735_emit_6654_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_3601807637515735_reloadSlickgrid_6656_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_3601807637515735_request_6652_getActionArgs($event) {
        return {
            operation: "update_register_item",
            data: {
                id: this.item.id,
                etag: this.item.etag,
                locked: true,
            },
        };
    }
    async evh_3601807637515735_clickPreventStop(event, scope) {
        return await this.actions.evh_3601807637515735_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_4139696446929656_emit_6660_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_4139696446929656_reloadSlickgrid_6662_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_4139696446929656_request_6658_getActionArgs($event) {
        return {
            operation: "update_register_item",
            data: {
                id: this.item.id,
                etag: this.item.etag,
                locked: false,
            },
        };
    }
    async evh_4139696446929656_clickPreventStop(event, scope) {
        return await this.actions.evh_4139696446929656_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_4700643919467772_emit_6666_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_4700643919467772_reloadSlickgrid_6668_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_4700643919467772_request_6664_getActionArgs($event) {
        return {
            operation: "update_register_item",
            data: {
                id: this.item.id,
                etag: this.item.etag,
                void: true,
            },
        };
    }
    async evh_4700643919467772_clickPreventStop(event, scope) {
        return await this.actions.evh_4700643919467772_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_295664594794476_emit_6672_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_295664594794476_reloadSlickgrid_6674_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_295664594794476_request_6670_getActionArgs($event) {
        return {
            operation: "update_register_item",
            data: {
                id: this.item.id,
                etag: this.item.etag,
                void: false,
            },
        };
    }
    async evh_295664594794476_clickPreventStop(event, scope) {
        return await this.actions.evh_295664594794476_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8474446275270171_emit_6676_getActionArgs($event) {
        return {
            event: "deleted",
        };
    }
    async evh_8474446275270171_success(event, scope) {
        return await this.actions.evh_8474446275270171_success.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1040167445267876_emit_6650 = new core_1.actions.EmitAction({
            actionArgs: this.act_1040167445267876_emit_6650_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_1040167445267876_clickPreventStop_6649 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_emit_6650,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_1040167445267876_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_clickPreventStop_6649],
        });
        const act_3601807637515735_emit_6654 = new core_1.actions.EmitAction({
            actionArgs: this.act_3601807637515735_emit_6654_getActionArgs,
            events: [],
        });
        const evh_3601807637515735_success_6653 = new core_1.actions.EventHandlerImpl({
            action: act_3601807637515735_emit_6654,
            event: "success",
            displayName: "emit",
        });
        const act_3601807637515735_reloadSlickgrid_6656 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_3601807637515735_reloadSlickgrid_6656_getActionArgs,
            events: [],
        });
        const evh_3601807637515735_success_6655 = new core_1.actions.EventHandlerImpl({
            action: act_3601807637515735_reloadSlickgrid_6656,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_3601807637515735_request_6652 = new core_1.actions.RequestAction({
            actionArgs: this.act_3601807637515735_request_6652_getActionArgs,
            displayName: "lock",
            events: [evh_3601807637515735_success_6653, evh_3601807637515735_success_6655],
        });
        const evh_3601807637515735_clickPreventStop_6651 = new core_1.actions.EventHandlerImpl({
            action: act_3601807637515735_request_6652,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_3601807637515735_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3601807637515735_clickPreventStop_6651],
        });
        const act_4139696446929656_emit_6660 = new core_1.actions.EmitAction({
            actionArgs: this.act_4139696446929656_emit_6660_getActionArgs,
            events: [],
        });
        const evh_4139696446929656_success_6659 = new core_1.actions.EventHandlerImpl({
            action: act_4139696446929656_emit_6660,
            event: "success",
            displayName: "emit",
        });
        const act_4139696446929656_reloadSlickgrid_6662 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_4139696446929656_reloadSlickgrid_6662_getActionArgs,
            events: [],
        });
        const evh_4139696446929656_success_6661 = new core_1.actions.EventHandlerImpl({
            action: act_4139696446929656_reloadSlickgrid_6662,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_4139696446929656_request_6658 = new core_1.actions.RequestAction({
            actionArgs: this.act_4139696446929656_request_6658_getActionArgs,
            displayName: "lock",
            events: [evh_4139696446929656_success_6659, evh_4139696446929656_success_6661],
        });
        const evh_4139696446929656_clickPreventStop_6657 = new core_1.actions.EventHandlerImpl({
            action: act_4139696446929656_request_6658,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_4139696446929656_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4139696446929656_clickPreventStop_6657],
        });
        const act_4700643919467772_emit_6666 = new core_1.actions.EmitAction({
            actionArgs: this.act_4700643919467772_emit_6666_getActionArgs,
            events: [],
        });
        const evh_4700643919467772_success_6665 = new core_1.actions.EventHandlerImpl({
            action: act_4700643919467772_emit_6666,
            event: "success",
            displayName: "emit",
        });
        const act_4700643919467772_reloadSlickgrid_6668 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_4700643919467772_reloadSlickgrid_6668_getActionArgs,
            events: [],
        });
        const evh_4700643919467772_success_6667 = new core_1.actions.EventHandlerImpl({
            action: act_4700643919467772_reloadSlickgrid_6668,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_4700643919467772_request_6664 = new core_1.actions.RequestAction({
            actionArgs: this.act_4700643919467772_request_6664_getActionArgs,
            displayName: "lock",
            events: [evh_4700643919467772_success_6665, evh_4700643919467772_success_6667],
        });
        const evh_4700643919467772_clickPreventStop_6663 = new core_1.actions.EventHandlerImpl({
            action: act_4700643919467772_request_6664,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_4700643919467772_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4700643919467772_clickPreventStop_6663],
        });
        const act_295664594794476_emit_6672 = new core_1.actions.EmitAction({
            actionArgs: this.act_295664594794476_emit_6672_getActionArgs,
            events: [],
        });
        const evh_295664594794476_success_6671 = new core_1.actions.EventHandlerImpl({
            action: act_295664594794476_emit_6672,
            event: "success",
            displayName: "emit",
        });
        const act_295664594794476_reloadSlickgrid_6674 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_295664594794476_reloadSlickgrid_6674_getActionArgs,
            events: [],
        });
        const evh_295664594794476_success_6673 = new core_1.actions.EventHandlerImpl({
            action: act_295664594794476_reloadSlickgrid_6674,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_295664594794476_request_6670 = new core_1.actions.RequestAction({
            actionArgs: this.act_295664594794476_request_6670_getActionArgs,
            displayName: "lock",
            events: [evh_295664594794476_success_6671, evh_295664594794476_success_6673],
        });
        const evh_295664594794476_clickPreventStop_6669 = new core_1.actions.EventHandlerImpl({
            action: act_295664594794476_request_6670,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_295664594794476_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_295664594794476_clickPreventStop_6669],
        });
        const act_8474446275270171_emit_6676 = new core_1.actions.EmitAction({
            actionArgs: this.act_8474446275270171_emit_6676_getActionArgs,
            events: [],
        });
        const evh_8474446275270171_success_6675 = new core_1.actions.EventHandlerImpl({
            action: act_8474446275270171_emit_6676,
            event: "success",
            displayName: "emit",
        });
        const evh_8474446275270171_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8474446275270171_success_6675],
        });
        return {
            act_1040167445267876_emit_6650,
            evh_1040167445267876_clickPreventStop_6649,
            evh_1040167445267876_clickPreventStop,
            act_3601807637515735_emit_6654,
            evh_3601807637515735_success_6653,
            act_3601807637515735_reloadSlickgrid_6656,
            evh_3601807637515735_success_6655,
            act_3601807637515735_request_6652,
            evh_3601807637515735_clickPreventStop_6651,
            evh_3601807637515735_clickPreventStop,
            act_4139696446929656_emit_6660,
            evh_4139696446929656_success_6659,
            act_4139696446929656_reloadSlickgrid_6662,
            evh_4139696446929656_success_6661,
            act_4139696446929656_request_6658,
            evh_4139696446929656_clickPreventStop_6657,
            evh_4139696446929656_clickPreventStop,
            act_4700643919467772_emit_6666,
            evh_4700643919467772_success_6665,
            act_4700643919467772_reloadSlickgrid_6668,
            evh_4700643919467772_success_6667,
            act_4700643919467772_request_6664,
            evh_4700643919467772_clickPreventStop_6663,
            evh_4700643919467772_clickPreventStop,
            act_295664594794476_emit_6672,
            evh_295664594794476_success_6671,
            act_295664594794476_reloadSlickgrid_6674,
            evh_295664594794476_success_6673,
            act_295664594794476_request_6670,
            evh_295664594794476_clickPreventStop_6669,
            evh_295664594794476_clickPreventStop,
            act_8474446275270171_emit_6676,
            evh_8474446275270171_success_6675,
            evh_8474446275270171_success,
            reload: act_1040167445267876_emit_6650,
            lock: act_295664594794476_request_6670,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcBillingListItemHeader.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcBillingListItemHeader.prototype, "onItem", null);
UcBillingListItemHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcBillingListItemHeader);
exports.default = UcBillingListItemHeader;
vue_property_decorator_1.Vue.component("UcBillingListItemHeader", UcBillingListItemHeader);
